import { useEffect, useRef, useState } from 'react'

export function useDebounce<T>(
  value: T,
  delay: number,
  initialDelay?: number
): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)
  const isFirstChange = useRef(true)

  const wait = isFirstChange.current ? (initialDelay ?? delay) : delay

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
      isFirstChange.current = false
    }, wait)

    return () => {
      clearTimeout(handler)
    }
  }, [value, wait])

  return debouncedValue
}
